import { CONTACT_INFO } from "src/common/constants";
import { ContactI, ContactInfoAction } from "../reducers/contactInfo";

export const CONTACT_INFO_SET_DATA = `${CONTACT_INFO}_SET_DATA` as const;

export const setContactInfo = (payload: ContactI[]): ContactInfoAction => ({
  type: CONTACT_INFO_SET_DATA,
  payload,
});
